export class VehicleConfigurationCompartmentCommandModel {
    public vehicleConfigurationCompartmentId: string;
    public serviceCategoryCode: string;
    public columnLayout: string;
    public columnCode: string;
    public physicalCapacity: number;
    public numberOfRows: number;
    public statusCode: string;
}